/**
 * Truncate document title for display in confirmation modals
 * @param title - The original title string
 * @param maxLength - Maximum length before truncation (default: 100)
 * @returns Truncated title with ellipsis if needed
 */
export function truncateTitleForModal(title: string, maxLength: number = 500): string {
  if (!title || title.length <= maxLength) {
    return title;
  }
  return title.slice(0, maxLength) + '...';
}